import React from "react";
import TrackInfoTool from "../../../../components/tools/TrackInfoTool";
import { useQuery } from "@tanstack/react-query";
import { COACH_SETTINGS_CLIENT_PORTAL_QUERY_KEY } from "../client-portal/CoachSettingsClientPortalRoute";
import WorkspacesService from "../../../../services/WorkspacesService";
import ClientPortalFeaturesSettings from "../../../../components/coach-nutrition-settings/ClientPortalFeturesSettings";

export default function NutritionSettingsRoute() {
  const { data: workspace } = useQuery({
    queryKey: [COACH_SETTINGS_CLIENT_PORTAL_QUERY_KEY],
    queryFn: WorkspacesService.getWorkspaceClientPortal,
  });

  return (
    <>
      {workspace && <ClientPortalFeaturesSettings workspace={workspace} />}
      <TrackInfoTool
        trackInfo={{
          name: "Coach - Nutrition Settings",
        }}
      />
    </>
  );
}
